<template>
  <div id="popupWindow">
    <el-button type="info" @click="close">
      <h-icon icon="icon-shangyi" rotate="-90"></h-icon>
      返回视图研判</el-button
    >
    <div class="header">
      <div class="left">
        <el-progress
          :text-inside="true"
          :stroke-width="26"
          :percentage="taskDetailID.progress"
        />
        <i class="iconfont icon-shanchu" />
        <span>刷新</span>
        <el-button type="success">扩大搜索</el-button>
      </div>

      <el-form :model="form" label-width="85px">
        <el-form-item label="查询对象">
          <el-select v-model="form.name">
            <el-option
              v-for="(item, index) in searchObjeList"
              :key="index"
              :label="item.label"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关注特征">
          <el-button type="success">{{ form.region }}</el-button>
        </el-form-item>
        <el-form-item label="视频来源">
          <el-select v-model="form.desc">
            <el-option
              v-for="(item, index) in videoList"
              :key="index"
              :label="item.sourceName"
              :value="item.sourceId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="aside">
        <div class="top">
          <cutImage v-model:itemInfo="topImgInfo"></cutImage>
        </div>
        <div class="botton">
          <MyMap ref="mapRef" style="width: 100%; height: 100%" />
        </div>
      </div>
      <div class="main">
        <div class="m-top">
          <div class="title" v-show="true">{{ titeleLabel[0] }}</div>
          <div class="one">
            <template v-if="showImg">
              <div
                v-for="item in oneRow"
                :key="item"
                class="one-item"
                :class="{ oneItemClick: item.resultId == resultId }"
              >
                <img
                  :src="item.fullUrl"
                  v-if="item.fullUrl"
                  :alt="item.sourceName"
                  @click="clickImg(item)"
                />
              </div>
            </template>
          </div>
          <div class="title" v-show="titeleLabel.length != 1">
            {{ titeleLabel[1] }}
          </div>
          <div class="one">
            <template v-if="showImg">
              <div
                v-for="item in twoRow"
                :key="item"
                class="one-item"
                :class="{ oneItemClick: item.resultId == resultId }"
              >
                <img
                  :src="item.fullUrl"
                  v-if="item.fullUrl"
                  :alt="item.sourceName"
                  @click="clickImg(item)"
                />
              </div>
            </template>
          </div>
          <div class="title" v-show="titeleLabel.length == 3">
            {{ titeleLabel[2] }}
          </div>
          <div class="one" v-if="!(titeleLabel.length == 2)">
            <template v-if="showImg">
              <div
                v-for="item in threeRow"
                :key="item"
                class="one-item"
                :class="{ oneItemClick: item.resultId == resultId }"
              >
                <img
                  :src="item.fullUrl"
                  v-if="item.fullUrl"
                  :alt="item.sourceName"
                  @click="clickImg(item)"
                />
              </div>
            </template>
          </div>
        </div>
        <div class="m-botton">
          <div class="progress">
            <div class="play">
              <div>
                <h-icon icon="icon-zhibohuifang"></h-icon>
                <span>
                  {{
                    moment(parseInt(taskDetailID.totalStartTime)).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  }}
                </span>
              </div>
              <div>
                <h-icon icon="icon-zanting"></h-icon>
                <span v-if="taskDetailID.totalEndTime">
                  {{
                    moment(parseInt(taskDetailID.totalEndTime)).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  }}
                </span>
              </div>
            </div>
            <el-slider
              v-model="currentTimer"
              :show-tooltip="true"
              :format-tooltip="formatTooltip"
            ></el-slider>
          </div>
          <div class="btns">
            <div>
              <el-button type="primary" @click="everyOpen">逐帧播放</el-button>
              <!-- <el-button type="success">逐页播放</el-button> -->
              <el-button type="primary" @click="stopOpen">停止</el-button>
              <el-select v-model="playTimers">
                <el-option
                  v-for="(item, index) in dropDownList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div>
              <el-button type="primary">全部下载</el-button>
              <span class="totalNum">共{{ totalNum }}页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  computed,
  ref,
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  watch,
  nextTick,
} from "vue";

import MyMap from "@/components/map/MyMap.vue";
import { Check, VideoPlay, VideoPause } from "@element-plus/icons-vue";
import moment from "moment";
import util from "@util/js";
import { ElMessage } from "element-plus";
import {
  getRetrieval,
  getClueTaskID,
  getClueSnapTotal,
} from "@/api/smartApplication/smartApplicationApi.js";
import cutImage from "./cutImage.vue";
export default defineComponent({
  name: "taskDetailDialog",
  components: { MyMap, cutImage },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editTaskInfo: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const state = reactive({
      form: {
        name: 1,
        region: "点击添加",
        desc: 1,
      },
      arr: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      searchObjeList: [
        { label: "人体", value: ["person"], code: 1, type: 1 },
        { label: "人脸", value: ["face"], code: 2, type: 1 },
        { label: "机动车", value: ["vehicle"], code: 3, type: 1 },
        { label: "非机动车", value: ["nonVehicle"], code: 4, type: 1 },
        { label: "人脸&人体", value: ["face", "person"], code: 5, type: 2 },
        {
          label: "人脸&人体&非机动车",
          value: ["face", "person", "nonVehicle"],
          code: 6,
          type: 3,
        },
        {
          label: "人体&非机动车",
          value: ["person", "nonVehicle"],
          code: 7,
          type: 2,
        },
        {
          label: "人脸&非机动车",
          value: ["face", "nonVehicle"],
          code: 8,
          type: 2,
        },
      ],
      videoList: [{ sourceName: "不限", sourceId: 1 }],

      titeleLabel: ["人体"],
      titeleValue: ["person"],
      titeleType: 1,
      // resData: {},
      resObj: {
        faces: "人脸",
        persons: "人体",
        nonVehicles: "非机动车",
        vehicles: "机动车",
      },
      totalImg: null,
      totalNum: 0, // 图片数量
      dropDownList: [
        { label: "X1", value: 8 },
        { label: "X2", value: 4 },
        { label: "X4", value: 2 },
        { label: "X8", value: 1 },
      ],
      editTaskInfo: {
        beginningClueTaskId: "",
        endTime: "",
        startTime: "",
        clueTaskId: "",
      },
      resultId: "",
      showImg: false,
      topImgInfo: null,
      showImgTime: null, // 播放计时器
      pageNum: 1, // 图片查询页码
      showImgIndex: 0, // 记录播放页数
      playTimers: 8, // 播放倍数
      currentTimer: 0, // 滑块当前时间
      taskDetailID: {
        progress: 0,
        totalStartTime: "",
        totalEndTime: "",
        startTime: "",
        endTime: "",
      },
    });
    const refData = toRefs(state);
    const mapRef = ref(null);
    watchEffect(() => {
      state.editTaskInfo = props.editTaskInfo;
      nextTick(async () => {
        await getClueTaskIDAsync();
        await getClueSnapTotalAsync();
        getRetrievalAsync();
      });
    });
    watch(
      () => state.form.name,
      () => {
        state.searchObjeList.forEach((element) => {
          if (element.code == state.form.name) {
            state.titeleLabel = element.label.split("&");
            state.titeleType = element.type;
            state.titeleValue = element.value;
          }
        });

        getRetrievalAsync();
        state.totalNum = state.titeleValue.reduce((pre, item) => {
          return pre + parseInt(state.totalImg[item + "Total"]);
        }, 0);
      },
      { deep: true }
    );
    watch(
      () => state.showImgIndex,
      () => {
        if (state.showImgIndex == state.allRow.length - 1) {
          state.pageNum++;
          getRetrievalAsync().then(() => {
            state.showImgIndex = 0;
          });
        }
      },
      { deep: true }
    );
    watch(
      () => state.playTimers,
      () => {
        if (state.showImgTime) {
          stopOpen();
          setTimeout(() => {
            everyOpen();
          });
        }
      },
      { deep: true }
    );
    watch(
      () => state.currentTimer,
      () => {
        changeCurrentTime();
      },
      { deep: true }
    );
    // 根据ID获取任务详情
    const getClueTaskIDAsync = async () => {
      const params = {
        clueTaskId: state.editTaskInfo.clueTaskId,
      };
      const res = await getClueTaskID(params);
      if (res.code == 0) {
        // state.taskDetailID.progress = res.data.progress;
        // state.taskDetailID.endTime = res.data.endTime;
        // state.taskDetailID.startTime = res.data.startTime;
        state.taskDetailID = res.data;
        res.data.totalClueTaskSourceList.forEach((el) => {
          state.videoList.push(el);
        });
        pointInfoArray(res.data.totalClueTaskSourceList);
      }
    };
    // 线索简介统计
    const getClueSnapTotalAsync = async () => {
      const params = {
        beginningClueTaskId: state.editTaskInfo.beginningClueTaskId,
        clueTaskType: 0,
        endTime: state.editTaskInfo.endTime,
        startTime: state.editTaskInfo.startTime,
      };
      const res = await getClueSnapTotal(params);
      if (res.code == 0) {
        state.totalImg = res.data;
        state.totalNum = parseInt(res.data.personTotal);
      }
    };
    // 添加接口中数据点位
    const pointInfoArray = (list) => {
      const array = list.filter((item, index) => {
        if (item.longitude && item.latitude) {
          return item;
        }
      });
      const newList = array.map((element, index) => {
        const pointInfo = {
          name: "",
          item: element,
          id: 1,
          type: 1,
          showType: 2,
          poiType: 3401,
          location: [],
          click: (e) => {
            state.showArrayPointDom = false;
            if (e.length > 1) {
              handleMapArrayClick(e);
              nextTick(() => {
                state.mapArrayPointData = e;
              });
            } else {
              handleMapIconClick(e);
              nextTick(() => {
                state.mapDataItem = element;
              });
            }
          },
        };
        pointInfo.id = index + 1;
        pointInfo.location[0] = parseFloat(element.longitude);
        pointInfo.location[1] = parseFloat(element.latitude);
        return pointInfo;
      });
      nextTick(() => {
        mapRef.value && mapRef.value.loadMarker(newList);
      });
    };
    //接口请求照片数据
    const getRetrievalAsync = async () => {
      console.log(props.editTaskInfo);
      let params = {
        beginningClueTaskId: props.editTaskInfo.beginningClueTaskId,
        clueTaskType: 0,
        endTime: props.editTaskInfo.endTime,
        startTime: props.editTaskInfo.startTime,
        pageNum: 1,
        pageSize: state.titeleType == 1 ? 30 : 10,
      };
      const res = await getRetrieval(params, {
        loading: true,
        loadingDom: ".main",
      });
      if (res.code == 0) {
        changeResData(res.data);
        console.log(res);
        state.showImg = true;
      }
    };
    //改变接口数据
    const changeResData = (list) => {
      for (let key in list) {
        if (list[key]) {
          let json2 = [];
          for (let i = 0; i < list[key].length; i += 10) {
            json2.push(list[key].slice(i, i + 10));
          }
          state.resObj[key] = json2;
        }
      }
      console.log(state.resObj);
      oneRow;
      twoRow;
      threeRow;
      state.allRow = [...oneRow.value, ...twoRow.value, ...threeRow.value];
      state.topImgInfo = state.allRow[0];
    };
    const oneRow = computed(() => {
      return state.resObj[state.titeleValue[0]][0];
    });
    const twoRow = computed(() => {
      return state.resObj[
        state.titeleLabel.length != 1
          ? state.titeleValue[1]
          : state.titeleValue[0]
      ][state.titeleLabel.length == 1 ? 1 : 0];
    });
    const threeRow = computed(() => {
      return state.resObj[
        state.titeleLabel.length == 3
          ? state.titeleValue[2]
          : state.titeleValue[0]
      ][state.titeleLabel.length == 3 ? 0 : 2];
    });
    //点击图片
    const clickImg = (item) => {
      state.topImgInfo = item;
      state.resultId = item.resultId;
    };

    const close = () => {
      context.emit("hideTrackQuery", false);
    };
    // 逐个播放
    const everyOpen = () => {
      if (!state.allRow) {
        ElMessage.warning("正在加载图片");
        return;
      }
      const index = state.allRow.length;
      if (!state.showImgTime) {
        state.topImgInfo = state.allRow[0];
        state.resultId = state.allRow[0].resultId;
        state.showImgIndex++;
      }
      state.showImgTime = setInterval(() => {
        if (state.showImgIndex < index) {
          state.topImgInfo = state.allRow[state.showImgIndex];
          state.resultId = state.allRow[state.showImgIndex].resultId;
          state.showImgIndex++;
        }
      }, state.playTimers * 500);
    };
    // 拖动时间
    const changeCurrentTime = util.debounceNow(() => {
      stopOpen();
      state.editTaskInfo.startTime =
        parseInt(state.taskDetailID.startTime) +
        (state.taskDetailID.endTime - state.taskDetailID.startTime) *
          (state.currentTimer / 100) +
        "";
      getRetrievalAsync();
    }, 1000);
    const stopOpen = () => {
      clearInterval(state.showImgTime);
    };
    //时间提示
    const formatTooltip = (value) => {
      return moment(
        parseInt(state.taskDetailID.startTime) +
          (state.taskDetailID.endTime - state.taskDetailID.startTime) *
            (value / 100)
      ).format("YYYY-MM-DD HH:mm:ss");
    };

    return {
      ...refData,
      Check,
      VideoPlay,
      VideoPause,
      moment,
      mapRef,
      close,
      clickImg,
      oneRow,
      twoRow,
      threeRow,
      everyOpen,
      stopOpen,
      formatTooltip,
    };
  },
});
</script>
<style lang="scss" scoped>
#popupWindow {
  width: 100%;
  height: 100%;
  // background-color: #1a2846;
  padding-top: 12px;
  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-right: 60px;
    .left {
      .el-progress {
        width: 200px;
        margin-right: 12px;
      }
      span {
        margin: 0 16px;
      }
      @include flex-row-c-c;
    }

    .el-form {
      display: flex;
      align-items: center;
    }
  }
  .content {
    display: flex;
    height: 90%;
    .aside {
      width: 30%;
      height: 100%;
      padding: 24px 16px;
      .top {
        width: 100%;
        height: 300px;
        margin-bottom: 16px;
        border: 1px dashed #333;
        position: relative;
        padding: 0px 0px;
        @include flex-row-c-c;
        img {
          width: 100%;
          height: 100%;
        }
        .operation {
          position: absolute;
          bottom: 30px;
          width: 95%;
          height: 50px;
          background-color: rgba($color: #000000, $alpha: 0.2);
          font-size: 14px;
          display: flex;
          align-items: center;
          .operation_item {
            .operation_conent {
              color: #fff;
              i {
                margin-right: 3px;
                color: #fff;
              }
              .icon-jianqie {
                font-size: 26px;
              }
            }
            .operation_conent:hover {
              color: #00fafa;
              i {
                color: #00fafa;
              }
            }
            margin: 0 6px;
          }
        }
      }
      .botton {
        width: 100%;
        height: 340px;
        border: 1px dashed #333;
      }
    }
    .main {
      width: 6%;
      height: 100%;
      padding: 20px;
      flex: 1;

      .m-top {
        .title {
          border-left: 4px solid #00fafa;
          padding-left: 8px;
          margin-bottom: 8px;
          height: 16px;
          line-height: 16px;
        }
        .one {
          height: 140px;
          display: flex;
          align-content: center;

          border: 1px solid #486199;
          padding: 12px;
          margin-bottom: 22px;
          background-color: #29324c;
          .one-item {
            margin-right: 32px;
            background: url("~@/assets/images/cardbg.png") no-repeat;
            background-size: contain;
            background-size: 100% 100%;
            width: 110px;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
            img {
              width: 90%;
              height: 90%;
            }
            &:hover {
              cursor: pointer;
            }
          }
          .oneItemClick {
            border: 1px solid #00fafa;
          }
        }
      }
      .m-botton {
        border: 1px solid #486199;
        padding: 10px 30px;
        .progress {
          .play {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }
        .btns {
          .el-button {
            width: 100px;
          }
          .el-select {
            margin-left: 20px;
            width: 120px;
          }
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 20px;
          .totalNum {
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>
